export const genders = [
    { code: 'fm', label: 'Male'},
    { code: 'ml', label: 'Female' },
    { code: 'oth', label: 'Other' },
];
